import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-news-box',
    templateUrl: './news-box.component.html',
    styleUrls: ['./news-box.component.scss']
})

export class NewsBoxComponent {

    constructor() { }

}
